__turbopack_context__.v({
  "feature": "ujAtBW_feature",
  "features": "ujAtBW_features",
  "wrapper": "ujAtBW_wrapper",
});
